import axios from 'axios';
import { toast } from 'react-toastify';

require('dotenv').config()

axios.defaults.xsrfCookieName = "CSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-CSRF-Token";
axios.defaults.withCredentials = true;

if (process.env.REACT_APP_MODE === 'development' ) {
  axios.defaults.baseURL = 'http://expo.test/api/'
  var default_image_url = 'http://expo.test'
} else {
  axios.defaults.baseURL = 'https://api-expo.irih.ir/api/'
  var default_image_url = 'https://api-expo.irih.ir'
}
export default default_image_url

axios.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  if(error.response) {
    if (error.response.status === 401 ) {
      toast.dismiss()
      toast.info("لطفا وارد شوید" , {position: 'bottom-right',className: 'foo-bar'})
      localStorage.removeItem("user")
      window.location = '/login';
    } else {
      return Promise.reject(error);
    }
  }
});
